<template>
    <div :class="['backgroundWrapper fansRanking-section', bgClass]">
        <div class="position-relative screen-topHeader">
            <span class="position-absolute backArrowIcon" id="close" @click="viewClose('someStatus')">
                <img :src='backWhiteArrow' alt="Back Arrow" />
            </span>
            <div class="text-center text-white fw-medium topHeader-title">Contributor</div>
        </div>
        <div class="listToggle justify-center">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" style="display: none;">
                    <div class="nav-link" :class="{ 'active': activeTab === 'thisweek' }"
                        @click="activateTab('thisweek')" data-toggle="tab" href="#thisweek" role="tab">Daily</div>
                </li>
                <li class="nav-item" @click="hideTimesBox">
                    <div class="nav-link" :class="{ 'active': activeTab === 'lastweek' }"
                        @click="activateTab('lastweek')" data-toggle="tab" href="#lastweek" role="tab">Weekly</div>
                </li>
                <li class="nav-item" @click="hideTimesBox">
                    <div class="nav-link" :class="{ 'active': activeTab === 'allData' }" @click="activateTab('allData')"
                        data-toggle="tab" href="#allData" role="tab">All</div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'thisweek' }" id="thisweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedDaily">
                    <FansRankingDailyTabCont />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'lastweek' }" id="lastweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedWeekly">
                    <FansRankingWeeklyTabCont />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'allData' }" id="allData" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedAllData">
                    <FansRankingAllDataTabCont />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { viewClose as androidViewClose } from '@/utils/android';
import backWhiteArrow from '../../assets/images/back-whiteArrow.svg';
import FansRankingDailyTabCont from './FansRankingDailyTabCont.vue'
import FansRankingWeeklyTabCont from './FansRankingWeeklyTabCont.vue'
import FansRankingAllDataTabCont from './FansRankingAllDataTabCont.vue'
export default {
    name: 'FansRankingTabs',
    components: {
        FansRankingDailyTabCont,
        FansRankingWeeklyTabCont,
        FansRankingAllDataTabCont,

    },
    data() {
        return {
            // activeTab: 'thisweek', 
            activeTab: 'lastweek',
            isLoadedDaily: false,
            isLoadedWeekly: false,
            isLoadedAllData: false,
            backWhiteArrow,
        };
    },
    computed: {
        bgClass() {
            switch (this.activeTab) {
                case 'thisweek': return 'daily-bg';
                case 'lastweek': return 'weekly-bg';
                case 'allData': return 'all-bg';
                default: return '';
            }
        }
    },
    methods: {
        activateTab(tabId) {
            this.activeTab = tabId;
            if (tabId === 'thisweek' && !this.isLoadedDaily) {
                this.isLoadedDaily = true
            }
            if (tabId === 'lastweek' && !this.isLoadedWeekly) {
                this.isLoadedWeekly = true
            }
            if (tabId === 'allData' && !this.isLoadedAllData) {
                this.isLoadedAllData = true
            }
        },

        //Close Webview on back arrow click
        viewClose(status) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                androidViewClose(status);
            }
        }

    },
    mounted() {
        // this.isLoadedDaily = true
        this.isLoadedWeekly = true
    }
}
</script>